
import { supabase } from "@/integrations/supabase/client";
import { NavigateFunction } from "react-router-dom";
import { clearProfileSnapshot } from "@/lib/profileSnapshot";

export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('supabase.auth.token');
  
  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  
  // Remove from sessionStorage
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
  
  // Remove app-specific storage
  localStorage.removeItem('profile-selection-shown');
  sessionStorage.removeItem('processing-payment');
  
  // Clear the profile snapshot for instant avatar
  clearProfileSnapshot();
};

export const signOutCompletely = async (navigate?: NavigateFunction) => {
  try {
    // Clean up auth state first
    cleanupAuthState();
    
    // Attempt global sign out
    try {
      await supabase.auth.signOut({ scope: 'global' });
    } catch (err) {
      console.warn('Sign out warning:', err);
    }
    
    // Use React Router navigation if available, otherwise fallback to window.location
    if (navigate) {
      navigate('/', { replace: true });
    } else {
      window.location.href = '/';
    }
  } catch (error) {
    console.error('Sign out error:', error);
    // Force redirect even if error
    if (navigate) {
      navigate('/', { replace: true });
    } else {
      window.location.href = '/';
    }
  }
};
